(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),s=o(c),f=n(8),d=o(f),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded",throttleDelay:99,debounceDelay:50,disableMutationObserver:!1},j=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,x),(0,b.default)(w,x.once),w},O=function(){w=(0,h.default)(),j()},M=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},S=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},_=function(e){x=i(x,e),w=(0,h.default)();var t=document.all&&!window.atob;return S(x.disable)||t?M():(x.disableMutationObserver||d.default.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),x.disableMutationObserver=!0),document.querySelector("body").setAttribute("data-aos-easing",x.easing),document.querySelector("body").setAttribute("data-aos-duration",x.duration),document.querySelector("body").setAttribute("data-aos-delay",x.delay),"DOMContentLoaded"===x.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?j(!0):"load"===x.startEvent?window.addEventListener(x.startEvent,function(){j(!0)}):document.addEventListener(x.startEvent,function(){j(!0)}),window.addEventListener("resize",(0,s.default)(j,x.debounceDelay,!0)),window.addEventListener("orientationchange",(0,s.default)(j,x.debounceDelay,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,x.once)},x.throttleDelay)),x.disableMutationObserver||d.default.ready("[data-aos]",O),w)};e.exports={init:_,refresh:j,refreshHard:O}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(f,t),M?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return S?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||S&&o>=y}function f(){var e=O();return c(e)?d(e):void(h=setTimeout(f,a(e)))}function d(e){return h=void 0,_&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(f,t),o(w)}return void 0===h&&(h=setTimeout(f,t)),g}var b,v,y,g,h,w,k=0,M=!1,S=!1,_=!0;if("function"!=typeof e)throw new TypeError(s);return t=u(t)||0,i(n)&&(M=!!n.leading,S="maxWait"in n,y=S?x(u(n.maxWait)||0,t):y,_="trailing"in n?!!n.trailing:_),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(s);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return f;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?f:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s="Expected a function",f=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(f,t),M?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return S?x(i,y-o):i}function s(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||S&&o>=y}function f(){var e=j();return s(e)?d(e):void(h=setTimeout(f,u(e)))}function d(e){return h=void 0,_&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=s(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(f,t),i(w)}return void 0===h&&(h=setTimeout(f,t)),g}var b,v,y,g,h,w,O=0,M=!1,S=!1,_=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(M=!!n.leading,S="maxWait"in n,y=S?k(a(n.maxWait)||0,t):y,_="trailing"in n?!!n.trailing:_),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==f}function a(e){if("number"==typeof e)return e;if(r(e))return s;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?s:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",s=NaN,f="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e){var t=void 0,o=void 0,i=void 0;for(t=0;t<e.length;t+=1){if(o=e[t],o.dataset&&o.dataset.aos)return!0;if(i=o.children&&n(o.children))return!0}return!1}function o(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}function i(){return!!o()}function r(e,t){var n=window.document,i=o(),r=new i(a);u=t,r.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}function a(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),o=Array.prototype.slice.call(e.removedNodes),i=t.concat(o);if(n(i))return u()})}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){};t.default={isSupported:i,ready:r}},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,s=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new s},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){return e=e||document.querySelectorAll("[data-aos]"),Array.prototype.map.call(e,function(e){return{node:e}})};t.default=n}])});
},{}],2:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

},{}],3:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":2,"./parse":4,"./stringify":5}],4:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }
        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'undefined' ? defaults.allowDots : !!options.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    if (typeof options.charset === 'undefined') {
        options.charset = defaults.charset;
    }

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};

},{"./utils":6}],5:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var formats = require('./formats');

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? defaults.allowDots : !!options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    var charset = options.charset || defaults.charset;
    if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly,
            charset
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":2,"./utils":6}],6:[function(require,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};

},{}],7:[function(require,module,exports){
/*!
 * simpleParallax.min - simpleParallax is a simple JavaScript library that gives your website parallax animations on any images or videos, 
 * @date: 20-08-2020 14:0:14, 
 * @version: 5.6.2,
 * @link: https://simpleparallax.com/
 */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define("simpleParallax",[],e):"object"==typeof exports?exports.simpleParallax=e():t.simpleParallax=e()}(window,(function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var r=e[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(i,r,function(e){return t[e]}.bind(null,r));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=0)}([function(t,e,n){"use strict";n.r(e),n.d(e,"default",(function(){return x}));var i=function(){return Element.prototype.closest&&"IntersectionObserver"in window};function r(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var s=new(function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.positions={top:0,bottom:0,height:0}}var e,n,i;return e=t,(n=[{key:"setViewportTop",value:function(t){return this.positions.top=t?t.scrollTop:window.pageYOffset,this.positions}},{key:"setViewportBottom",value:function(){return this.positions.bottom=this.positions.top+this.positions.height,this.positions}},{key:"setViewportAll",value:function(t){return this.positions.top=t?t.scrollTop:window.pageYOffset,this.positions.height=t?t.clientHeight:document.documentElement.clientHeight,this.positions.bottom=this.positions.top+this.positions.height,this.positions}}])&&r(e.prototype,n),i&&r(e,i),t}()),o=function(t){return NodeList.prototype.isPrototypeOf(t)||HTMLCollection.prototype.isPrototypeOf(t)?Array.from(t):"string"==typeof t||t instanceof String?document.querySelectorAll(t):[t]},a=function(){for(var t,e="transform webkitTransform mozTransform oTransform msTransform".split(" "),n=0;void 0===t;)t=void 0!==document.createElement("div").style[e[n]]?e[n]:void 0,n+=1;return t}(),l=function(t){return"img"!==t.tagName.toLowerCase()&&"picture"!==t.tagName.toLowerCase()||!!t&&(!!t.complete&&(void 0===t.naturalWidth||0!==t.naturalWidth))};function u(t){return function(t){if(Array.isArray(t))return c(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||function(t,e){if(!t)return;if("string"==typeof t)return c(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return c(t,e)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function c(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,i=new Array(e);n<e;n++)i[n]=t[n];return i}function h(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var f=function(){function t(e,n){var i=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.element=e,this.elementContainer=e,this.settings=n,this.isVisible=!0,this.isInit=!1,this.oldTranslateValue=-1,this.init=this.init.bind(this),this.customWrapper=this.settings.customWrapper&&this.element.closest(this.settings.customWrapper)?this.element.closest(this.settings.customWrapper):null,l(e)?this.init():this.element.addEventListener("load",(function(){setTimeout((function(){i.init(!0)}),50)}))}var e,n,i;return e=t,(n=[{key:"init",value:function(t){var e=this;this.isInit||(t&&(this.rangeMax=null),this.element.closest(".simpleParallax")||(!1===this.settings.overflow&&this.wrapElement(this.element),this.setTransformCSS(),this.getElementOffset(),this.intersectionObserver(),this.getTranslateValue(),this.animate(),this.settings.delay>0?setTimeout((function(){e.setTransitionCSS(),e.elementContainer.classList.add("simple-parallax-initialized")}),10):this.elementContainer.classList.add("simple-parallax-initialized"),this.isInit=!0))}},{key:"wrapElement",value:function(){var t=this.element.closest("picture")||this.element,e=this.customWrapper||document.createElement("div");e.classList.add("simpleParallax"),e.style.overflow="hidden",this.customWrapper||(t.parentNode.insertBefore(e,t),e.appendChild(t)),this.elementContainer=e}},{key:"unWrapElement",value:function(){var t=this.elementContainer;this.customWrapper?(t.classList.remove("simpleParallax"),t.style.overflow=""):t.replaceWith.apply(t,u(t.childNodes))}},{key:"setTransformCSS",value:function(){!1===this.settings.overflow&&(this.element.style[a]="scale(".concat(this.settings.scale,")")),this.element.style.willChange="transform"}},{key:"setTransitionCSS",value:function(){this.element.style.transition="transform ".concat(this.settings.delay,"s ").concat(this.settings.transition)}},{key:"unSetStyle",value:function(){this.element.style.willChange="",this.element.style[a]="",this.element.style.transition=""}},{key:"getElementOffset",value:function(){var t=this.elementContainer.getBoundingClientRect();if(this.elementHeight=t.height,this.elementTop=t.top+s.positions.top,this.settings.customContainer){var e=this.settings.customContainer.getBoundingClientRect();this.elementTop=t.top-e.top+s.positions.top}this.elementBottom=this.elementHeight+this.elementTop}},{key:"buildThresholdList",value:function(){for(var t=[],e=1;e<=this.elementHeight;e++){var n=e/this.elementHeight;t.push(n)}return t}},{key:"intersectionObserver",value:function(){var t={root:null,threshold:this.buildThresholdList()};this.observer=new IntersectionObserver(this.intersectionObserverCallback.bind(this),t),this.observer.observe(this.element)}},{key:"intersectionObserverCallback",value:function(t){var e=this;t.forEach((function(t){t.isIntersecting?e.isVisible=!0:e.isVisible=!1}))}},{key:"checkIfVisible",value:function(){return this.elementBottom>s.positions.top&&this.elementTop<s.positions.bottom}},{key:"getRangeMax",value:function(){var t=this.element.clientHeight;this.rangeMax=t*this.settings.scale-t}},{key:"getTranslateValue",value:function(){var t=((s.positions.bottom-this.elementTop)/((s.positions.height+this.elementHeight)/100)).toFixed(1);return t=Math.min(100,Math.max(0,t)),0!==this.settings.maxTransition&&t>this.settings.maxTransition&&(t=this.settings.maxTransition),this.oldPercentage!==t&&(this.rangeMax||this.getRangeMax(),this.translateValue=(t/100*this.rangeMax-this.rangeMax/2).toFixed(0),this.oldTranslateValue!==this.translateValue&&(this.oldPercentage=t,this.oldTranslateValue=this.translateValue,!0))}},{key:"animate",value:function(){var t,e=0,n=0;(this.settings.orientation.includes("left")||this.settings.orientation.includes("right"))&&(n="".concat(this.settings.orientation.includes("left")?-1*this.translateValue:this.translateValue,"px")),(this.settings.orientation.includes("up")||this.settings.orientation.includes("down"))&&(e="".concat(this.settings.orientation.includes("up")?-1*this.translateValue:this.translateValue,"px")),t=!1===this.settings.overflow?"translate3d(".concat(n,", ").concat(e,", 0) scale(").concat(this.settings.scale,")"):"translate3d(".concat(n,", ").concat(e,", 0)"),this.element.style[a]=t}}])&&h(e.prototype,n),i&&h(e,i),t}();function m(t){return function(t){if(Array.isArray(t))return y(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||d(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function p(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],i=!0,r=!1,s=void 0;try{for(var o,a=t[Symbol.iterator]();!(i=(o=a.next()).done)&&(n.push(o.value),!e||n.length!==e);i=!0);}catch(t){r=!0,s=t}finally{try{i||null==a.return||a.return()}finally{if(r)throw s}}return n}(t,e)||d(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function d(t,e){if(t){if("string"==typeof t)return y(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?y(t,e):void 0}}function y(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,i=new Array(e);n<e;n++)i[n]=t[n];return i}function v(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var g,b,w=!1,T=[],x=function(){function t(e,n){if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),e&&i()){if(this.elements=o(e),this.defaults={delay:0,orientation:"up",scale:1.3,overflow:!1,transition:"cubic-bezier(0,0,0,1)",customContainer:"",customWrapper:"",maxTransition:0},this.settings=Object.assign(this.defaults,n),this.settings.customContainer){var r=p(o(this.settings.customContainer),1);this.customContainer=r[0]}this.lastPosition=-1,this.resizeIsDone=this.resizeIsDone.bind(this),this.refresh=this.refresh.bind(this),this.proceedRequestAnimationFrame=this.proceedRequestAnimationFrame.bind(this),this.init()}}var e,n,r;return e=t,(n=[{key:"init",value:function(){var t=this;s.setViewportAll(this.customContainer),T=[].concat(m(this.elements.map((function(e){return new f(e,t.settings)}))),m(T)),w||(this.proceedRequestAnimationFrame(),window.addEventListener("resize",this.resizeIsDone),w=!0)}},{key:"resizeIsDone",value:function(){clearTimeout(b),b=setTimeout(this.refresh,200)}},{key:"proceedRequestAnimationFrame",value:function(){var t=this;s.setViewportTop(this.customContainer),this.lastPosition!==s.positions.top?(s.setViewportBottom(),T.forEach((function(e){t.proceedElement(e)})),g=window.requestAnimationFrame(this.proceedRequestAnimationFrame),this.lastPosition=s.positions.top):g=window.requestAnimationFrame(this.proceedRequestAnimationFrame)}},{key:"proceedElement",value:function(t){(this.customContainer?t.checkIfVisible():t.isVisible)&&t.getTranslateValue()&&t.animate()}},{key:"refresh",value:function(){s.setViewportAll(this.customContainer),T.forEach((function(t){t.getElementOffset(),t.getRangeMax()})),this.lastPosition=-1}},{key:"destroy",value:function(){var t=this,e=[];T=T.filter((function(n){return t.elements.includes(n.element)?(e.push(n),!1):n})),e.forEach((function(e){e.unSetStyle(),!1===t.settings.overflow&&e.unWrapElement()})),T.length||(window.cancelAnimationFrame(g),window.removeEventListener("resize",this.refresh),w=!1)}}])&&v(e.prototype,n),r&&v(e,r),t}()}]).default}));
},{}],8:[function(require,module,exports){
/* smoothscroll v0.4.0 - 2018 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;

      do {
        el = el.parentNode;

        isBody = el === d.body;
      } while (isBody === false && isScrollable(el) === false);

      isBody = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (typeof exports === 'object' && typeof module !== 'undefined') {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());

},{}],9:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// import { TimelineLite, Power2 } from 'gsap';
var _window = window,
    TimelineLite = _window.TimelineLite,
    Power2 = _window.Power2; // Manage all show-hide accordions

_toConsumableArray(document.querySelectorAll('.js-accordion')).forEach(function (accordion) {
  var $accordionContent = accordion.querySelector('.js-accordion__content');
  accordion.querySelector('.js-accordion__trigger').addEventListener('click', function () {
    var timeline = new TimelineLite();

    if (!accordion.classList.contains('js-accordion--open')) {
      // Find the expanded height
      timeline.set($accordionContent, {
        visibility: 'hidden',
        position: 'absolute',
        display: 'block'
      });
      var openHeight = $accordionContent.offsetHeight; // Reset styles

      timeline.set($accordionContent, {
        height: 0,
        position: '',
        visibility: 'visible'
      }).call(function () {
        accordion.classList.add('js-accordion--open');
      }) // Animate to the open state
      .to($accordionContent, 0.2, {
        height: openHeight,
        ease: Power2.easeInOut
      }).set($accordionContent, {
        height: 'auto'
      });
    } else {
      accordion.classList.remove('js-accordion--open');
      timeline.to($accordionContent, 0.2, {
        height: 0,
        ease: Power2.easeInOut
      }).set($accordionContent, {
        display: 'none',
        height: 'auto'
      });
    }
  });
});

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Industries =
/*#__PURE__*/
function () {
  function Industries(Utils) {
    _classCallCheck(this, Industries);

    this.industries = document.querySelectorAll('.industries-served .buttons button');

    if (!this.industries) {
      return;
    }

    this.init();
  }

  _createClass(Industries, [{
    key: "_closeAllIndustryInfo",
    value: function _closeAllIndustryInfo() {
      Array.prototype.forEach.call(this.industries, function (industry) {
        industry.classList.remove('open');
      });
    }
  }, {
    key: "_closeIndustryInfo",
    value: function _closeIndustryInfo(industry) {
      var closeBtn = industry.querySelector('.close');

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          industry.classList.remove('open');
        });
        closeBtn.addEventListener('keyup', function (e) {
          e.stopPropagation();
        });
      }
    } // Fire event if user clicks or presses the enter button

  }, {
    key: "_enterEventHandler",
    value: function _enterEventHandler(element, callback) {
      var events = ['click', 'keyup'];
      Array.prototype.forEach.call(events, function (event) {
        element.addEventListener(event, function (e) {
          if (event !== 'click' && e.keyCode !== 13) {
            return;
          }

          callback(e);
        });
      });
    }
  }, {
    key: "_openIndustryInfo",
    value: function _openIndustryInfo(industry) {
      var _this = this;

      this._enterEventHandler(industry, function (e) {
        _this._closeAllIndustryInfo();

        industry.classList.add('open');
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;

      Array.prototype.forEach.call(this.industries, function (industry) {
        _this2._openIndustryInfo(industry);

        _this2._closeIndustryInfo(industry);
      });
    }
  }]);

  return Industries;
}();

var _default = Industries;
exports.default = _default;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HotJobsFilter =
/*#__PURE__*/
function () {
  function HotJobsFilter() {
    _classCallCheck(this, HotJobsFilter);

    this.$filterComponent = $('#cp-custom-filter-simple');

    if (this.$filterComponent.length <= 0) {
      console.error("#cp-custom-filter-simple does not exist");
      return;
    }

    this.$openBtn = $('#cp-custom-filter-simple-open-btn');
    this.$dropdown = $('#cp-custom-filter-simple-open-dropdown');
    this.init();
  } // Private Methods


  _createClass(HotJobsFilter, [{
    key: "_closeDropdown",
    value: function _closeDropdown() {
      this.$dropdown.removeClass('show');
      this.$openBtn.attr('aria-expanded', 'false');
    }
  }, {
    key: "_fetchJobs",
    value: function _fetchJobs(country) {
      $.ajax({
        url: window.location.pathname,
        type: 'GET',
        data: {
          country: country
        },
        success: function success(res) {
          $('.hot-jobs .columns').html(res);
        }
      });
    }
  }, {
    key: "_openDropdown",
    value: function _openDropdown() {
      this.$dropdown.addClass('show');
      this.$openBtn.attr('aria-expanded', 'true');
    }
  }, {
    key: "_startLoading",
    value: function _startLoading() {
      $('.hot-jobs .loading').addClass('show');
    }
  }, {
    key: "_updateButtonText",
    value: function _updateButtonText(country) {
      this.$openBtn.text(country);
    }
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      var country = $(e.currentTarget).data('country');

      if (!country) {
        return;
      }

      this._closeDropdown();

      this._startLoading();

      this._updateButtonText(country);

      this._fetchJobs(country);
    }
  }, {
    key: "setupEvents",
    value: function setupEvents() {
      var _this = this;

      this.$openBtn.on('click', function (e) {
        e.stopPropagation();

        _this._openDropdown();
      }); // On Options Click

      var $option = this.$filterComponent.find('li');
      $option.on('click', function (e) {
        _this._onClick(e);
      });
      $option.on('keypress', function (e) {
        if (event.which != 13) {
          return;
        }

        _this._onClick(e);
      }); // On Window Click

      $(window).on('click', function (e) {
        _this._closeDropdown();
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.setupEvents();
    }
  }]);

  return HotJobsFilter;
}();

var _default = HotJobsFilter;
exports.default = _default;

},{}],12:[function(require,module,exports){
"use strict";

// Handle adding more that one attachment to a form
var addAttachmentButton = document.querySelector('.contact-form-section__add-attachment, .form-builder .add-attachment');
var buttonLimit = 4;

if (addAttachmentButton) {
  addAttachmentButton.addEventListener('click', function () {
    // Add a new file input
    var newInput = document.createElement('input');
    newInput.setAttribute('type', 'file');
    newInput.setAttribute('name', 'attachment[]');
    addAttachmentButton.parentNode.insertBefore(newInput, addAttachmentButton); // Hide the button if we've reached our limit

    if (document.querySelectorAll('.contact-form-section input[name="attachment[]"], .form-builder input[name="attachment[]"]').length >= buttonLimit) {
      addAttachmentButton.style.display = 'none';
    }
  });
}

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Finds dropdown class and adds open class to it
var Dropdown =
/*#__PURE__*/
function () {
  function Dropdown() {
    _classCallCheck(this, Dropdown);

    this.setupEvents();
  }

  _createClass(Dropdown, [{
    key: "setupEvents",
    value: function setupEvents() {
      var $dropdown = jQuery('.dropdown');

      if ($dropdown.length > 0) {
        $dropdown.find('button, .dropdown-button').on('click', function () {
          var $this = jQuery(this);
          var $parent = $this.parent('.dropdown');
          $parent.toggleClass('open');
        });
      }

      jQuery('.dropdown-container').on('click', function () {
        jQuery(this).toggleClass('open');
      });
    }
  }]);

  return Dropdown;
}();

var _default = Dropdown;
exports.default = _default;

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initEntryFilters;

var _qs = _interopRequireDefault(require("qs"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var resizeThrottler = new _utils.ResizeThrottler(); // Height of filter lists, along with the top margin
// If you edit this, change it in the css as well

var FILTER_HEIGHT = 285 + 35;

var EntryFilter =
/*#__PURE__*/
function () {
  function EntryFilter(el) {
    var _this = this;

    _classCallCheck(this, EntryFilter);

    this.el = el;
    this.label = el.querySelector('.filter-item__label');
    this.list = el.querySelector('.filter-item__list');
    this.items = _toConsumableArray(this.el.querySelectorAll('.filter-item__item label'));
    this.queryParam = el.getAttribute('data-query-param');
    this.isMultiSelect = el.getAttribute('data-multi-select');
    this.clearOnSelect = el.getAttribute('data-clear-on-select');
    this.filterContainer = document.querySelector('.entry-filter__filters'); // Attach "Select all" and "Clear all" handlers

    if (this.isMultiSelect) {
      this.el.querySelector('.filter-item__select-all').addEventListener('click', this.selectAll.bind(this));
      this.el.querySelector('.filter-item__clear-all').addEventListener('click', this.deselectAll.bind(this));
    } // Open and close the dropdowns


    this.label.addEventListener('click', function () {
      _this.toggleDropdown();
    });
    this.items.forEach(function (item) {
      var input = item.querySelector('input'); // Emulate :focus styles

      input.addEventListener('focus', function () {
        item.classList.add('focused');
      });
      input.addEventListener('blur', function () {
        item.classList.remove('focused');
      }); // Handle selecting and deselecting

      input.addEventListener('change', _this.handleItemChange.bind(_this));
    });
  }

  _createClass(EntryFilter, [{
    key: "addSiblingFilters",
    value: function addSiblingFilters(filters) {
      this.siblingFilters = filters;
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      if (this.list.style.display === 'block') this.closeDropdown();else this.openDropdown();
    }
  }, {
    key: "openDropdown",
    value: function openDropdown() {
      // First, close other dropdowns
      if (this.siblingFilters) {
        this.siblingFilters.forEach(function (siblingFilter) {
          return siblingFilter.closeDropdown(true);
        });
      } // Then open this one


      this.el.classList.add('open');
      this.list.style.display = 'block';
      this.clampFilter();
      this.el.style.height = this.el.offsetHeight + Math.min(this.list.offsetHeight + 35, FILTER_HEIGHT) + 'px';
      this.showShadow();
    }
  }, {
    key: "clampFilter",
    value: function clampFilter() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth;
      var listLeftDistance = this.list.getBoundingClientRect().left;
      var filterContainerRightDistance = windowWidth - this.filterContainer.getBoundingClientRect().right;
      this.list.style.width = 'calc(100vw - ' + (listLeftDistance + 20) + 'px)';
      this.list.style.maxWidth = 'calc(100vw - ' + (listLeftDistance + filterContainerRightDistance) + 'px)';
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown(keepShadow) {
      this.el.classList.remove('open');
      this.list.style.display = 'none';
      this.el.style.height = 'auto';
      if (!keepShadow) this.hideShadow();
    }
  }, {
    key: "hideShadow",
    value: function hideShadow() {
      document.querySelector('.entry-filter').classList.remove('expanded');
    }
  }, {
    key: "showShadow",
    value: function showShadow() {
      document.querySelector('.entry-filter').classList.add('expanded');
    }
  }, {
    key: "handleItemChange",
    value: function handleItemChange(e) {
      if (!this.isMultiSelect) {
        this.selectRadioItem(e.currentTarget);
      } else if (e.currentTarget.checked) {
        this.selectCheckboxItem(e.currentTarget);
      } else {
        this.deselectCheckboxItem(e.currentTarget);
      }
    }
  }, {
    key: "selectRadioItem",
    value: function selectRadioItem(item) {
      // Create new URL
      var oldQuery = _qs.default.parse(window.location.search, {
        ignoreQueryPrefix: true
      });

      var newParams = _objectSpread({}, oldQuery, _defineProperty({}, this.queryParam, item.getAttribute('value')));

      this.navigate(newParams); // Deselect other labels

      this.items.forEach(function (label) {
        label.classList.remove('selected');
      }); // Update this label's style

      item.parentElement.classList.add('selected');
    }
  }, {
    key: "deselectCheckboxItem",
    value: function deselectCheckboxItem(item) {
      // Create new URL
      var oldQuery = _qs.default.parse(window.location.search, {
        ignoreQueryPrefix: true
      });

      var newParams = _objectSpread({}, oldQuery, _defineProperty({}, this.queryParam, oldQuery[this.queryParam].filter(function (param) {
        return param !== item.getAttribute('value');
      })));

      this.navigate(newParams); // Update label style

      item.parentElement.classList.remove('selected');
    }
  }, {
    key: "selectCheckboxItem",
    value: function selectCheckboxItem(item) {
      // Create new URL
      var oldQuery = _qs.default.parse(window.location.search, {
        ignoreQueryPrefix: true
      });

      var newParams = _objectSpread({}, oldQuery, _defineProperty({}, this.queryParam, [].concat(_toConsumableArray(oldQuery[this.queryParam] || []), [item.getAttribute('value')])));

      this.navigate(newParams); // Update label style

      item.parentElement.classList.add('selected');
    }
  }, {
    key: "navigate",
    value: function navigate(newParams) {
      var baseUrl = window.location.origin + window.location.pathname;

      if (this.clearOnSelect) {
        newParams[this.clearOnSelect] = undefined; // remove this key from the output
      }

      var newQuery = _qs.default.stringify(newParams, {
        arrayFormat: 'brackets',
        addQueryPrefix: true
      }); // if (window.history && window.history.pushState) {


      if (false) {
        window.history.pushState(null, null, baseUrl + newQuery);
      } else {
        window.location = baseUrl + newQuery;
      }
    }
  }, {
    key: "deselectAll",
    value: function deselectAll() {
      // Create new URL
      var oldQuery = _qs.default.parse(window.location.search, {
        ignoreQueryPrefix: true
      });

      var newParams = _objectSpread({}, oldQuery, _defineProperty({}, this.queryParam, undefined));

      this.navigate(newParams); // Update label style

      this.items.forEach(function (item) {
        item.parentElement.classList.remove('selected');
      });
    }
  }, {
    key: "selectAll",
    value: function selectAll() {
      // Create new URL
      var oldQuery = _qs.default.parse(window.location.search, {
        ignoreQueryPrefix: true
      });

      var newParams = _objectSpread({}, oldQuery, _defineProperty({}, this.queryParam, this.items.map(function (item) {
        return item.querySelector('input').getAttribute('value');
      })));

      this.navigate(newParams); // Update label style

      this.items.forEach(function (item) {
        item.parentElement.classList.add('selected');
      });
    }
  }]);

  return EntryFilter;
}();

function initEntryFilters() {
  // Set up filters
  var entryFilters = _toConsumableArray(document.querySelectorAll('.filter-item')).map(function (el) {
    return new EntryFilter(el);
  });

  entryFilters.forEach(function (entryFilter) {
    entryFilter.addSiblingFilters(entryFilters.filter(function (item) {
      return item !== entryFilter;
    }));
    resizeThrottler.add(function () {
      return entryFilter.clampFilter();
    });
  }); // Set up search listeners

  var search = document.querySelector('.entry-filter__search');

  if (search) {
    var searchExpanded;
    var button = search.querySelector('.entry-filter__search-button');
    button.addEventListener('click', function (e) {
      if (!searchExpanded) {
        e.preventDefault();
        search.classList.add('entry-filter__search--open');
        searchExpanded = true;
        search.querySelector('input').focus();
        if (window.flexibility) window.flexibility(document.documentElement);
      }
    }); // Close it back up when someone clicks away

    document.addEventListener('click', function (e) {
      if (!search.contains(e.target)) {
        search.classList.remove('entry-filter__search--open');
        searchExpanded = false;
        if (window.flexibility) window.flexibility(document.documentElement);
      }
    });
  } // Close all filters when someone clicks elsewhere


  var filterContainer = document.querySelector('.entry-filter__filters');

  if (filterContainer) {
    document.addEventListener('click', function (e) {
      if (!filterContainer.contains(e.target)) {
        entryFilters.forEach(function (entryFilter) {
          return entryFilter.closeDropdown();
        });
      }
    });
  }
}

},{"./utils":24,"qs":3}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Note: These will become imports when we get done with the current Gulp setup
var _window = window,
    InfiniteScroll = _window.InfiniteScroll,
    Isotope = _window.Isotope;
var resizeThrottler = new _utils.ResizeThrottler();

var InfiniteScrollSection =
/*#__PURE__*/
function () {
  function InfiniteScrollSection(elem) {
    var _this = this;

    _classCallCheck(this, InfiniteScrollSection);

    this.dom = elem;
    this.itemsWrapper = elem.querySelector('.infinite-scroll__item-wrapper');
    this.startingPage = this.itemsWrapper.getAttribute('data-starting-page');
    this.craftRequestUrl = this.itemsWrapper.getAttribute('data-craft-request-url');
    this.isotope = null; // Set up view buttons if we're in the News view

    this.manageView = !!document.querySelector('.entry-filter__view');
    this.view = elem.classList.contains('news--grid') ? 'grid' : 'list';

    if (this.manageView) {
      this.listViewToggle = document.querySelector('#list-view-toggle');
      this.gridViewToggle = document.querySelector('#grid-view-toggle');
      this.listViewToggle.addEventListener('click', function () {
        _this.handleViewClick('list');
      });
      this.gridViewToggle.addEventListener('click', function () {
        _this.handleViewClick('grid');
      });
      this.updateView();
    } // Begin!


    this.initInfiniteScroll();
    resizeThrottler.add(function () {
      return _this.updateIsotope();
    });
  }

  _createClass(InfiniteScrollSection, [{
    key: "handleViewClick",
    value: function handleViewClick(gridOrList) {
      if (this.view === gridOrList) return false;
      if (this.view === 'grid') this.view = 'list';else this.view = 'grid';
      return this.updateView();
    }
  }, {
    key: "updateView",
    value: function updateView() {
      if (this.view === 'grid') {
        // Switch to grid view
        this.dom.classList.remove('news--list');
        this.dom.classList.add('news--grid');
        this.listViewToggle.classList.remove('active');
        this.gridViewToggle.classList.add('active');
      } else {
        // Switch to list view
        this.dom.classList.remove('news--grid');
        this.dom.classList.add('news--list');
        this.gridViewToggle.classList.remove('active');
        this.listViewToggle.classList.add('active');
      }

      this.updateIsotope();
    }
  }, {
    key: "updateIsotope",
    value: function updateIsotope() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      if (this.view === 'grid' && windowWidth >= _utils.MOBILE_BREAKPOINT && !this.isotope) {
        // Init isotope
        this.isotope = new Isotope(this.itemsWrapper, {
          itemSelector: '.news-item',
          masonry: {
            gutter: 20
          }
        });
      } else if ((this.view === 'list' || windowWidth < _utils.MOBILE_BREAKPOINT) && this.isotope) {
        // Kill isotope if we're switching to list view or mobile
        this.isotope.destroy();
        this.isotope = null;
      }
    }
  }, {
    key: "initInfiniteScroll",
    value: function initInfiniteScroll() {
      var _this2 = this;

      if (_utils.IS_IE9) {
        // We can't infinite scroll, so just change the button to be more explicit
        var loadMoreText = this.dom.querySelector('.infinite-scroll__message--load-more-button a .btn__text');
        if (loadMoreText) loadMoreText.textContent = 'Next page';
      } else {
        var craftRequestUrl = this.craftRequestUrl,
            startingPage = this.startingPage; // Initialize infinite scroll

        var options = {
          path: function path() {
            // Path is included manually here because InfiniteScroll chokes on query params
            var nextPageNum = this.pageIndex + parseInt(startingPage, 10);
            var pageNum = "p".concat(nextPageNum).concat(window.location.search);

            if (craftRequestUrl == window.location.origin + '/') {
              return "".concat(craftRequestUrl).concat(pageNum);
            }

            return "".concat(craftRequestUrl).concat(pageNum);
          },
          append: '.infinite-scroll__item-wrapper > *',
          checkLastPage: '.infinite-scroll__message--load-more-button a',
          scrollThreshold: false,
          debug: true
        };
        this.infiniteScroll = new InfiniteScroll(this.itemsWrapper, options); // Attach our event listeners for infinite scroll

        var loadMoreButton = this.dom.querySelector('.infinite-scroll__message--load-more-button a');

        if (loadMoreButton) {
          this.dom.querySelector('.infinite-scroll__message--load-more-button a').addEventListener('click', function (e) {
            e.preventDefault();

            _this2.doInfiniteScroll();

            _this2.dom.querySelector('.infinite-scroll__message--load-more-button').style.display = 'none';
            _this2.dom.querySelector('.infinite-scroll__message--infinite-scroll-request').style.display = 'block';
          });
        }

        this.infiniteScroll.on('load', function () {
          _this2.dom.querySelector('.infinite-scroll__message--infinite-scroll-request').style.display = 'none';
        });
        this.infiniteScroll.on('last', function () {
          _this2.dom.querySelector('.infinite-scroll__message--infinite-scroll-last').style.display = 'block';
          _this2.dom.querySelector('.infinite-scroll__message--load-more-button').style.display = 'none';
        });
        this.infiniteScroll.on('append', function (response, path, items) {
          if (_this2.isotope) {
            // Trigger isotope to re-layout masonry
            _this2.isotope.appended(items);

            _this2.isotope.layout();
          }

          var nextLoadMoreButton = response.querySelector('.infinite-scroll__message--load-more-button a');

          if (nextLoadMoreButton) {
            var nextUrl = nextLoadMoreButton.getAttribute('href');

            _this2.dom.querySelector('.infinite-scroll__message--load-more-button a').setAttribute('href', nextUrl);

            if (_this2.infiniteScroll.canLoad) {
              _this2.dom.querySelector('.infinite-scroll__message--load-more-button').style.display = 'block';
            }
          }
        });
      }
    }
  }, {
    key: "doInfiniteScroll",
    value: function doInfiniteScroll() {
      if (!this.infiniteScroll) this.initInfiniteScroll();
      this.infiniteScroll.loadNextPage();
    }
  }]);

  return InfiniteScrollSection;
}();

function initInfiniteScrollSections() {
  _toConsumableArray(document.querySelectorAll('.infinite-scroll')).map(function (el) {
    return new InfiniteScrollSection(el);
  });
}

var _default = initInfiniteScrollSections;
exports.default = _default;

},{"./utils":24}],16:[function(require,module,exports){
"use strict";

var _utils = require("./utils");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _window = window,
    TweenMax = _window.TweenMax,
    $ = _window.$;
var resizeThrottler = new _utils.ResizeThrottler(); // const NAV_HEIGHT = 70;
// const OPEN_NAV_HEIGHT = 180;

function desktopWidth() {
  return $(document).width() > _utils.NAV_BREAKPOINT;
} // Set full height for tertiary nav dropdowns


var fullTertiaryHeightSet = false;

function setFullTertiaryHeight() {
  if (fullTertiaryHeightSet) {
    // We're done our job, stop listening
    resizeThrottler.remove(setFullTertiaryHeight);
  } else if (desktopWidth()) {
    // Set out full height
    _toConsumableArray(document.querySelectorAll('.nav-drop__tertiary:not(:empty)')).forEach(function (el) {
      el.style.maxHeight = 'none';
      el.style.setProperty('--full-height', el.offsetHeight + 'px');
      el.style.maxHeight = '0';
      fullTertiaryHeightSet = true;
    });
  }
}

setFullTertiaryHeight();
resizeThrottler.add(setFullTertiaryHeight); // Show and hide top banner

var topBanner = $('.top-banner');
var topBannerId = topBanner.attr('id');
var topBannerHeight;
var displayTopBanner = true;

function positionTopBanner() {
  topBannerHeight = topBanner.height();
  topBanner.css('top', -1 * topBannerHeight);
  topBanner.animate({
    top: 0
  }, 'slow');
  $('.nav-bar, .hidden-nav-gradient').animate({
    top: topBannerHeight
  }, 'slow');
  $('body').animate({
    'margin-top': topBannerHeight
  }, 'slow');
}

function repositionTopBanner() {
  topBannerHeight = topBanner.height();
  $('.nav-bar, .hidden-nav-gradient').css('top', topBannerHeight);
  $('body').css('margin-top', topBannerHeight);
}

function closeTopBanner() {
  displayTopBanner = false;
  $('.nav-bar, .hidden-nav-gradient').animate({
    top: 0
  }, 'slow');
  $('body').animate({
    'margin-top': 0
  }, 'slow');
  topBanner.animate({
    top: -1 * topBannerHeight
  }, 'slow');
  setTimeout(function () {
    topBanner.css('display', 'none');
  }, 600);
  localStorage.setItem(topBannerId, true);
}

if (topBanner.length && !localStorage.getItem(topBannerId)) {
  positionTopBanner();
  $('#js-close-top-banner').on('click', closeTopBanner);
} else {
  displayTopBanner = false;
}

var searchBoxTimeline;

function openNav() {
  if (desktopWidth()) {
    if ($('.top-banner').css('display') === 'none') {
      TweenMax.set('.nav-bar', {
        clearProps: 'top'
      });
    } else {
      TweenMax.set('.nav-bar', {
        top: topBannerHeight || 0
      });
    }
  }
}

function closeNav() {
  $('.nav-bar').removeClass('nav-bar--active');
}

$(window).resize(function () {
  var ww = $(window).width();
  resetAnimations();

  if (ww >= mobileBreakpoint) {
    (0, _utils.enableBodyScroll)();
  }

  if (topBanner.length && displayTopBanner) repositionTopBanner();

  if (ww >= _utils.NAV_BREAKPOINT) {
    $('body, .nav-bar').removeClass('mobile-nav-open');
  }
});

function resetAnimations() {
  if ($('.search-box').data('open')) {
    var dropdown = $('.command-panel__drop');
    var dropdownWidth = dropdown.innerWidth();
    var searchForm = $('form.search-box');
    var searchBox = searchForm.parent('.nav-icons__icon');
    var searchInput = $('.search-box__input');
    var nonSearchIcons = $('.nav-icons__icon').slice(1);
    var reverseTimeLine = new TimelineLite();
    reverseTimeLine.set([searchBox, searchInput, dropdown, '.search-box__icon', '.search-box', '.nav-icons', '.search-box__label', '.nav-icon-wrapper', '.nav-icon', '.close-search'], {
      clearProps: 'all'
    });
    $('.search-box').data('open', false);
  }
}

function toggleMobileNav() {
  $('.nav-drop__primary, .nav-drop__secondary, .nav-drop__tertiary').removeClass('nav-drop--open');

  if ($('.nav-bar').hasClass('mobile-nav-open')) {
    $('.nav-bar').removeClass('mobile-nav-open');
    (0, _utils.enableBodyScroll)();
  } else {
    $('.nav-bar').addClass('mobile-nav-open');
    (0, _utils.disableBodyScroll)();
  }
}

$('#activate-mobile-nav').click(toggleMobileNav); // if you click a link in the mobile nav that takes you to another hash location on the same page, close the nav and go there

$('a.nav-underline').on('click', function (e) {
  if ($(window).width() <= _utils.NAV_BREAKPOINT // is mobile
  && $('.nav-bar').hasClass('mobile-nav-open') // mobile nav is open
  && this.href.indexOf('#') > 1 // is a hash link
  && $(this.href.split('/')).last()[0].replace(/#.*/, '') == $(window.location.href.split('/')).last()[0].replace(/#.*/, '')) // destination is the current page
    {
      toggleMobileNav();
      window.location.href = this.href;
    }
}); // Toggle secondary nav menus on mobile

_toConsumableArray(document.querySelectorAll('.nav-drop__item--primary')).forEach(function (el) {
  var secondaryList = el.querySelector('.nav-drop__secondary');

  if (secondaryList) {
    el.addEventListener('click', function (e) {
      if (!desktopWidth()) {
        if (!secondaryList.classList.contains('nav-drop--open')) {
          // prevent navigation so we can open the dropdown
          e.preventDefault();
        } // close the other lists and open this one


        _toConsumableArray(document.querySelectorAll('.nav-drop__secondary')).forEach(function (list) {
          list.classList.remove('nav-drop--open');
        });

        secondaryList.classList.add('nav-drop--open');
      }
    }); // Toggle tertiary nav menus on mobile

    _toConsumableArray(secondaryList.querySelectorAll('.nav-drop__item--secondary')).forEach(function (secondaryListItem) {
      var tertiaryList = secondaryListItem.querySelector('.nav-tertiary');

      if (tertiaryList) {
        secondaryListItem.querySelector('.nav-icon-row').addEventListener('click', function (e) {
          if (!desktopWidth()) {
            if (!tertiaryList.classList.contains('nav-tertiary--open')) {
              // prevent navigation so we can open the dropdown
              e.preventDefault();
            } // close the other lists and open this one


            _toConsumableArray(document.querySelectorAll('.nav-tertiary')).forEach(function (list) {
              list.classList.remove('nav-tertiary--open');
            });

            tertiaryList.classList.add('nav-tertiary--open');

            _toConsumableArray(secondaryList.querySelectorAll('.nav-drop__item--secondary')).forEach(function (otherList) {
              otherList.style.height = 'auto';
            });

            var height = secondaryListItem.offsetHeight + tertiaryList.offsetHeight + 'px';
            secondaryListItem.style.height = height;
          }
        });
      }
    });
  }
});

function desktopSearchAnimation() {
  // console.info('trigger Deskstop search anim')
  var dropdown = $('.command-panel__drop');
  var searchBox = $('.search-box__input');
  var searchForm = $('form.search-box').addClass('search-box--open');
  var iconsHeight = $('.nav-icons').height();
  var labelHeight = $('.search-box__label').innerHeight();
  var searchIconRight = $('.search-box__icon').css('right');
  var dropdownWidth = dropdown.innerWidth();
  $('.nav-drop').removeClass('nav-drop--active');
  closeNav();
  $('.search-box').data('open', true);
  searchBoxTimeline = new TimelineLite({
    paused: true
  });
  searchBoxTimeline.add('start', 0);
  searchBoxTimeline.add('widenBox', 0.25);
  searchBoxTimeline.add('heightenBox', 1.25);
  var logoSearchBuffer = 150;
  var searchBoxWidth = $('.nav').width() - $('.nav__logo').width() - logoSearchBuffer;
  $('.nav-icons').height(iconsHeight); // Squash label with the search icon, lock height of the form, fade in form border

  searchBoxTimeline.to('.search-box__label', 0.25, {
    height: 0
  }, 'start');
  searchBoxTimeline.to('.search-box__icon', 0.25, {
    y: labelHeight / 2
  }, 'start');
  searchBoxTimeline.to(searchBox, 0.25, {
    height: iconsHeight
  }, 'start');
  searchBoxTimeline.to('.search-box', 0.25, {
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,1)'
  }, 'start');
  searchBoxTimeline.to('.command-panel__icons', 0.25, {
    borderWidth: 0
  }, 'start'); // Spread out the search box as we simultaneously wipe the dropdown

  searchBoxTimeline.to(searchBox, 1, {
    width: searchBoxWidth
  }, 'widenBox');
  searchBoxTimeline.to('.search-box__icon', 0.2, {
    right: 12
  }, 'widenBox');
  searchBoxTimeline.to('.search-box', 0.25, {
    paddingLeft: 10,
    paddingRight: 0
  }, 'widenBox');
  searchBoxTimeline.to(dropdown, 1, {
    width: 0
  }, 'widenBox');
  searchBoxTimeline.to(dropdown, 1.5, {
    borderColor: 'rgba(255,255,255,0)'
  }, 'widenBox');
  var closeSearchTimeLine = new TimelineLite();
  var nonSearchIcons = $('.nav-icons__icon').slice(1);
  closeSearchTimeLine.to(nonSearchIcons, 0.25, {
    autoAlpha: 0
  });
  closeSearchTimeLine.to('.close-search', 0.25, {
    autoAlpha: 1
  });
  searchBoxTimeline.add(closeSearchTimeLine, 'start'); // Fade in the placeholder text

  searchBoxTimeline.to(searchBox, 1, {
    opacity: 1
  }, 'heightenBox');
  searchBoxTimeline.play();
  searchBox.focus();
}

function mobileSearchAnimation() {
  // console.info("trigger Mobile search anim")
  var dropdown = $('.command-panel__drop');
  var dropdownWidth = dropdown.innerWidth();
  var searchForm = $('form.search-box').addClass('search-box--open');
  var searchBox = searchForm.parent('.nav-icons__icon');
  var searchInput = $('.search-box__input');
  var nonSearchIcons = $('.nav-icons__icon').slice(1);
  searchBoxTimeline = new TimelineLite({
    paused: true
  });
  $('.search-box').data('open', true);
  var duration = 1;
  searchBoxTimeline.add('fadeOut', 0);
  searchBoxTimeline.add('widenBox', 0.25);
  searchBoxTimeline.to(nonSearchIcons, 0.25, {
    autoAlpha: 0,
    display: 'none'
  }, 'fadeOut');
  searchBoxTimeline.to('.search-box__label', 0.25, {
    height: 0
  }, 'fadeOut');
  searchBoxTimeline.to(searchBox, duration, {
    width: dropdownWidth - 38
  }, 'widenBox');
  searchBoxTimeline.to(nonSearchIcons, duration, {
    width: 0
  }, 'widenBox');
  searchBoxTimeline.to(searchInput, 1, {
    width: '100%',
    opacity: 1
  }, 'widenBox');
  searchBoxTimeline.to('.nav-icon', duration, {
    paddingLeft: 0,
    paddingRight: 0
  }, 'widenBox');
  var closeSearchTimeLine = new TimelineLite();
  closeSearchTimeLine.to('.close-search', 0.25, {
    autoAlpha: 1
  });
  searchBoxTimeline.add(closeSearchTimeLine);
  searchBoxTimeline.play();
  searchInput.focus();
} // Animate search box


$('.search-box').click(function (e) {
  if ($('.nav-bar').hasClass('mobile-nav-open')) {
    mobileSearchAnimation();
  } else {
    desktopSearchAnimation();
  }
});

function desktopCloseSearchAnimation() {
  var searchForm = $('form.search-box').removeClass('search-box--open');
  var dropdown = $('.command-panel__drop');
  var searchBox = $('.search-box__input');
  var iconsHeight = $('.nav-icons').height();
  var labelHeight = $('.search-box__label').innerHeight();
  var searchIconRight = $('.search-box__icon').css('right');
  var dropdownWidth = dropdown.innerWidth();
  var reverseTimeLine = new TimelineLite({
    paused: true
  });
  reverseTimeLine.add('start', 0);
  reverseTimeLine.add('shrinkBox', 0.25);
  reverseTimeLine.to(searchBox, 0.1, {
    opacity: 0
  }, 'start');
  reverseTimeLine.to(searchBox, 0.5, {
    width: 0
  }, 'shrinkBox');
  reverseTimeLine.to('.search-box__icon', 0.2, {
    right: 5
  }, 'shrinkBox');
  reverseTimeLine.to('.search-box', 0.25, {
    paddingLeft: 0,
    paddingRight: 0
  }, 'shrinkBox');
  reverseTimeLine.to(dropdown, 0.5, {
    width: dropdownWidth
  }, 'shrinkBox');
  reverseTimeLine.to(dropdown, 0.3, {
    borderColor: 'rgba(255,255,255,1)'
  }, 'shrinkBox');
  reverseTimeLine.to('.search-box', 0.25, {
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0)'
  });
  reverseTimeLine.call(function () {
    searchBoxTimeline.pause(0);
  });
  reverseTimeLine.set([searchBox, dropdown, '.search-box__icon', '.search-box', '.nav-icons', '.search-box__label', '.close-search'], {
    clearProps: 'all'
  });
  reverseTimeLine.play();
}

function mobileCloseSearchAnimation() {
  var dropdown = $('.command-panel__drop');
  var dropdownWidth = dropdown.innerWidth();
  var searchForm = $('form.search-box').removeClass('search-box--open');
  var searchBox = searchForm.parent('.nav-icons__icon');
  var searchInput = $('.search-box__input');
  var nonSearchIcons = $('.nav-icons__icon').slice(1);
  var reverseTimeLine = new TimelineLite({
    paused: true
  });
  reverseTimeLine.call(function () {
    searchBoxTimeline.pause(0);
  });
  reverseTimeLine.set([searchBox, searchInput, dropdown, '.search-box__icon', '.search-box', '.nav-icons', '.search-box__label', '.nav-icon-wrapper', '.nav-icon', '.close-search'], {
    clearProps: 'all'
  });
  reverseTimeLine.play();
}

$('.close-search').click(function (e) {
  searchBoxTimeline.kill();

  if ($('.nav-bar').hasClass('mobile-nav-open')) {
    mobileCloseSearchAnimation();
  } else {
    desktopCloseSearchAnimation();
  }
});

},{"./utils":24}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PayPalPayFlow =
/*#__PURE__*/
function () {
  function PayPalPayFlow() {
    _classCallCheck(this, PayPalPayFlow);

    this.$paymentFormContainer = $('.payment-form');

    if (this.$paymentFormContainer.length <= 0) {
      return;
    }

    this.$paymentForm = this.$paymentFormContainer.find('form');
    this.res_messages = {
      'FILL_REQUIRED_FIELDS': 'Please fill out all required fields',
      'GENERAL_ISSUE': 'An issue has occurred. Please try again!',
      'RECAPTCHA_VERIFICATION_FAILED': 'reCAPTCHA verification failed, please try again.'
    };
    this.init();
  }

  _createClass(PayPalPayFlow, [{
    key: "_resetForm",
    value: function _resetForm() {
      this.$paymentForm[0].reset();
    }
  }, {
    key: "_showFormMessage",
    value: function _showFormMessage(message) {
      var formMessage = this.res_messages[message] ? this.res_messages[message] : message;
      this.$paymentFormContainer.find('.form-message').text(formMessage);
    }
  }, {
    key: "_showThankYou",
    value: function _showThankYou() {
      this.$paymentFormContainer.find('.thank-you').addClass('show');
      this.$paymentForm.remove();
    }
  }, {
    key: "_submitToPayPal",
    value: function _submitToPayPal() {
      $('#submit-paypal').click();
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction() {
      var isValid = this.validate();

      if (!isValid) {
        grecaptcha.reset();
        return;
      }

      $.ajax({
        url: '/actions/payPalPayFlow/transactions/sendTransaction',
        type: 'POST',
        dataType: 'json',
        data: this.$paymentForm.serialize(),
        context: this,
        success: function success(res) {
          if (res.status === 200) {
            this._submitToPayPal();

            return;
          }

          grecaptcha.reset();

          this._showFormMessage(res.message);
        },
        error: function error(err) {
          grecaptcha.reset();

          if (err.status === 403) {
            this._showFormMessage('There was an error trying to send your message. Please try again.');

            return;
          }

          this._showFormMessage('Server is not responding. Please try again.');
        }
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      var address = $('input[name="address"]').val();
      var amount = $('input[name="AMOUNT"]').val();
      var city = $('input[name="city"]').val();
      var company = $('input[name="company"]').val();
      var email = $('input[name="EMAIL"]').val();
      var employer = $('input[name="COMMENT2"]').val();
      var invoice = $('input[name="INVOICE"]').val();
      var name = $('input[name="NAME"]').val();
      var phone = $('input[name="PHONE"]').val();
      var policy = $('input[name="COMMENT1"]').val();
      var state = $('select[name="state"]').val();
      var zip = $('input[name="zip"]').val();

      if (!address || !amount || !city || !company || !email || !employer || !invoice || !name || !phone || !policy || !state || !zip) {
        this._showFormMessage('FILL_REQUIRED_FIELDS');

        return false;
      }

      return true;
    }
  }, {
    key: "init",
    value: function init() {
      window.PayPalPayFlow = this; // This method is used in the _paymentForm.twig file
    }
  }]);

  return PayPalPayFlow;
}();

var _default = PayPalPayFlow;
exports.default = _default;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PopupDynamic =
/*#__PURE__*/
function () {
  function PopupDynamic() {
    _classCallCheck(this, PopupDynamic);

    this.$popupTemplate = this._checkElementExists('#dynamic-popup-template');
    this.$displayContainer = this._checkElementExists('#dynamic-popup-display-container');
    this.popupHTML = this.$popupTemplate.html();
  }

  _createClass(PopupDynamic, [{
    key: "removePopup",
    value: function removePopup() {
      $('#dynamic-popup-display-container .dynamic-popup-carousel').remove();
      this.popupHTML = this._checkElementExists('#dynamic-popup-template').html();
    }
  }, {
    key: "_checkElementExists",
    value: function _checkElementExists(element) {
      var $element = $(element);

      if ($element.length <= 0) {
        console.error("".concat(element, " does not exist"));
        return;
      }

      return $element;
    }
  }, {
    key: "setHTML",
    value: function setHTML(html) {
      this.removePopup();
      this.popupHTML = this.popupHTML.replace(/{ popup }/g, html);
      return this;
    }
  }, {
    key: "setPosition",
    value: function setPosition(position) {
      this.popupHTML = this.popupHTML.replace(/{ position }/g, position);
      return this;
    }
  }, {
    key: "show",
    value: function show() {
      this.$displayContainer.append(this.popupHTML);
    }
  }]);

  return PopupDynamic;
}();

var _default = PopupDynamic;
exports.default = _default;

},{}],19:[function(require,module,exports){
"use strict";

var _utils = _interopRequireDefault(require("./utils"));

var _entryFilter = _interopRequireDefault(require("./entry-filter"));

var _infiniteScroll = _interopRequireDefault(require("./infinite-scroll"));

var _wallOfGratitude = _interopRequireDefault(require("./wall-of-gratitude"));

var _paypalPayflow = _interopRequireDefault(require("./paypal-payflow"));

var _dropdown = _interopRequireDefault(require("./dropdown"));

var _hamburgerMenu = _interopRequireDefault(require("./thought-leadership/hamburger-menu"));

var _industries = _interopRequireDefault(require("./brand-protection/industries"));

var _videoModal = _interopRequireDefault(require("./video-modal"));

var _popupDynamic = _interopRequireDefault(require("./popup-dynamic"));

var _hotJobsFilter = _interopRequireDefault(require("./components/hot-jobs-filter"));

require("./smooth-scroll");

require("./accordions");

require("./tabs");

require("./utility-nav");

require("./contact-form");

require("./nav-bar");

var _aos = _interopRequireDefault(require("aos"));

var _simpleParallaxJs = _interopRequireDefault(require("simple-parallax-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _entryFilter.default)();
(0, _infiniteScroll.default)();
(0, _utils.default)(); // Thought Leadership Page

new _dropdown.default();
new _hamburgerMenu.default(); // Brand Leadership

new _industries.default(); // Payment Form (PayPal PayFlow)

new _paypalPayflow.default(); // Used on Season of Giving page only

if ($('.cheer-comments').length > 0) {
  window.WallOfGratitude = new _wallOfGratitude.default();
}

if (window.flexibility) window.flexibility(document.documentElement); // Rims 2021 Page

if ($('#rims-page').length > 0) {
  var rimsCloseAllAccordions = function rimsCloseAllAccordions($accordionComponent) {
    $accordionComponent.find('.accordion').removeClass('open');
  };

  var rimsEvents = function rimsEvents() {
    $('.accordions-component .accordion').on('click', function () {
      var $accordion = $(this);
      var $accordionComponent = $accordion.parents('.accordions-component');
      var singleOpen = $accordionComponent.hasClass('single');
      var currentlyOpen = $accordion.hasClass('open');

      if (singleOpen) {
        rimsCloseAllAccordions($accordionComponent);

        if (currentlyOpen) {
          return;
        }
      }

      $accordion.toggleClass('open');
    });
  };

  var $rimsAccordions = $('.accordions-component .accordion');
  rimsEvents(); // Video Modal

  new _videoModal.default();
}

function hasElement($element) {
  if ($element.length <= 0) {
    return false;
  }

  return true;
} // On Season of Giving 2021 Page


if (hasElement($('#season-of-giving-2021'))) {
  var sogPopupInit = function sogPopupInit() {
    var $popupDynamic = new _popupDynamic.default(); // Events

    $('.dynamic-popup-btn').on('click', function () {
      var position = $(this).attr('data-position');
      var popupHTML = $(this).parent().next('.popup')[0].outerHTML;
      $popupDynamic.setHTML(popupHTML).setPosition(position).show();
    });
    $('#dynamic-popup-display-container').on('click', '.dynamic-popup-close-btn', function (e) {
      e.stopPropagation();
      $popupDynamic.removePopup();
    });
  };

  var sogParallax = function sogParallax() {
    var mountainImage = document.getElementsByClassName('mountain');
    new _simpleParallaxJs.default(mountainImage, {
      orientation: 'down',
      scale: 1.2
    });
  };

  sogPopupInit();
  sogParallax();
} // On Careers Page


if (hasElement($('#careers-landing-page'))) {
  var careersPopupInit = function careersPopupInit() {
    var $popupDynamic = new _popupDynamic.default();
    $('.dynamic-popup-btn').on('click', function () {
      var popupHTML = $(this).parent().next('.popup')[0].outerHTML;
      $popupDynamic.setHTML(popupHTML).show();
    });
    $('#dynamic-popup-display-container').on('click', '.dynamic-popup-close-btn', function (e) {
      e.stopPropagation();
      $popupDynamic.removePopup();
    });
  };

  careersPopupInit(); // Hot Jobs Section

  new _hotJobsFilter.default();
} // On Season of Giving 2021 and Careers Page


if (hasElement($('#season-of-giving-2021')) || hasElement($('#careers-landing-page'))) {
  _aos.default.init({
    duration: 800,
    easing: 'ease',
    once: true
  });
}

},{"./accordions":9,"./brand-protection/industries":10,"./components/hot-jobs-filter":11,"./contact-form":12,"./dropdown":13,"./entry-filter":14,"./infinite-scroll":15,"./nav-bar":16,"./paypal-payflow":17,"./popup-dynamic":18,"./smooth-scroll":20,"./tabs":21,"./thought-leadership/hamburger-menu":22,"./utility-nav":23,"./utils":24,"./video-modal":25,"./wall-of-gratitude":26,"aos":1,"simple-parallax-js":7}],20:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

require('smoothscroll-polyfill').polyfill(); // Use smooth scrolling for same-page anchor links


var commentsBoxes = document.querySelectorAll('.comments-box');

_toConsumableArray(document.querySelectorAll('a:not(.skip-link):not(.open-chat)')).forEach(function (elem) {
  var href = elem.getAttribute('href');
  elem.addEventListener('click', function (e) {
    // Ignore links that aren't scroll anchors
    if (!/^(\/)?#/.test(href)) return false; // Ignore links inside comment boxes

    if (_toConsumableArray(commentsBoxes).some(function (commentBox) {
      return commentBox.contains(elem);
    })) {
      return false;
    } // Otherwise stop the event and smoothscroll instead


    e.preventDefault();
    var scrollDestination = 0;

    if (!/^(\/)?#$/.test(href)) {
      // We're scrolling to an element, not to the top of the page
      var destination = document.querySelector(href);

      if (destination) {
        // Use the distance from the element to the top of the viewport, plus the amount we've scrolled
        var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
        scrollDestination = destination.getBoundingClientRect().top + scrollTop;
      }
    }

    return window.scrollTo({
      top: scrollDestination,
      left: 0,
      behavior: 'smooth'
    });
  });
});

},{"smoothscroll-polyfill":8}],21:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// Switch selected tab on click
_toConsumableArray(document.querySelectorAll('.tabs')).forEach(function (tabGroup) {
  var tabs = _toConsumableArray(tabGroup.querySelectorAll('.tabs__content'));

  var toggles = _toConsumableArray(tabGroup.querySelectorAll('.tabs__toggle button'));

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      // On toggle click, deactivate all toggles and tabs
      [].concat(_toConsumableArray(toggles), _toConsumableArray(tabs)).forEach(function (toggle) {
        return toggle.classList.remove('active');
      }); // And activate this toggle and its tab

      [].concat(_toConsumableArray(tabs.filter(function (tab) {
        return tab.getAttribute('data-tab-handle') === toggle.getAttribute('data-tab-handle');
      })), [toggle]).forEach(function (el) {
        return el.classList.add('active');
      });
    });
  });
});

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HamburgerMenu =
/*#__PURE__*/
function () {
  function HamburgerMenu() {
    _classCallCheck(this, HamburgerMenu);

    this.$sideNav = jQuery('#side-nav');
    this.init();
  }

  _createClass(HamburgerMenu, [{
    key: "openHamburgerMenu",
    value: function openHamburgerMenu() {
      this.$sideNav.addClass('open');
    }
  }, {
    key: "closeHamburgerMenu",
    value: function closeHamburgerMenu() {
      this.$sideNav.removeClass('open');
    }
  }, {
    key: "setupEvents",
    value: function setupEvents() {
      var _this = this;

      jQuery('#btn-open-nav').on('click', function (e) {
        e.stopPropagation();

        _this.openHamburgerMenu();
      });
      jQuery('#btn-close-nav').on('click', function () {
        _this.closeHamburgerMenu();
      });
      jQuery('body').on('click', function (e) {
        _this.closeHamburgerMenu();
      });
      jQuery('#side-nav').on('click', function (e) {
        e.stopPropagation();
      });
      jQuery('#side-nav .title').on('click', function (e) {
        e.preventDefault();
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.setupEvents();
    }
  }]);

  return HamburgerMenu;
}();

var _default = HamburgerMenu;
exports.default = _default;

},{}],23:[function(require,module,exports){
"use strict";

var _utils = require("./utils");

var scrollThrottler = new _utils.ScrollThrottler();
var utilityNav = document.querySelector('.utility-nav');
var navBar = document.querySelector('.nav-bar');
var covidBand = document.getElementById('covid-band'); // transform: translateY(-21px);

var oldScrollPosition = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

function updateUtilityNav() {
  var newScrollPosition = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

  if (newScrollPosition < oldScrollPosition || newScrollPosition <= 0) {
    navBar.classList.remove('nav-bar--hide-utility');

    if (covidBand != null) {
      covidBand.classList.remove('nav-bar--hide-utility');
    }
  } else {
    navBar.classList.add('nav-bar--hide-utility');

    if (covidBand != null) {
      covidBand.classList.add('nav-bar--hide-utility');
    }
  }

  oldScrollPosition = newScrollPosition;
} // Only attach this handler if we're showing the utility nav on the current page


if (utilityNav) {
  updateUtilityNav();
  scrollThrottler.add(updateUtilityNav);
}

},{"./utils":24}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hideFocusStylesForMouse;
exports.disableBodyScroll = disableBodyScroll;
exports.enableBodyScroll = enableBodyScroll;
exports.ResizeThrottler = exports.ScrollThrottler = exports.IS_IE9 = exports.MOBILE_BREAKPOINT = exports.NAV_BREAKPOINT = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Site constants
var NAV_BREAKPOINT = 920;
exports.NAV_BREAKPOINT = NAV_BREAKPOINT;
var MOBILE_BREAKPOINT = 600;
exports.MOBILE_BREAKPOINT = MOBILE_BREAKPOINT;
var IS_IE9 = window.isIE9 || false; // Only hide :focus styles when the user is using a mouse

exports.IS_IE9 = IS_IE9;

function hideFocusStylesForMouse() {
  document.body.addEventListener('mousedown', function () {
    document.body.classList.add('using-mouse');
  });
  document.body.addEventListener('keydown', function () {
    document.body.classList.remove('using-mouse');
  });
} // Body scroll managers


var $body = document.querySelector('body');
var $hiddenNavGradient = document.querySelector('.hidden-nav-gradient');

function disableBodyScroll() {
  var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
  $body.style.overflow = 'hidden';
  $body.style.position = 'fixed';
  $body.style.top = scrollTop * -1 + 'px';
  if ($hiddenNavGradient) $hiddenNavGradient.style.display = 'none';
}

function enableBodyScroll() {
  $body.style.overflow = 'auto';
  $body.style.position = 'static';
  $body.style.top = 0;
  if ($hiddenNavGradient) $hiddenNavGradient.style.display = 'block';
} // Event throttlers


var ScrollThrottler =
/*#__PURE__*/
function () {
  function ScrollThrottler() {
    _classCallCheck(this, ScrollThrottler);

    this.scrollTimeout = null;
    this.scrollFunctions = [];
    this.throttle = this.throttle.bind(this);
    window.addEventListener('scroll', this.throttle, false);
  }

  _createClass(ScrollThrottler, [{
    key: "add",
    value: function add(fn) {
      this.scrollFunctions.push(fn);
    }
  }, {
    key: "remove",
    value: function remove(fn) {
      this.scrollFunctions = this.scrollFunctions.filter(function (setFn) {
        return setFn !== fn;
      });
    }
  }, {
    key: "throttle",
    value: function throttle() {
      var _this = this;

      if (!this.scrollTimeout) {
        this.scrollTimeout = setTimeout(function () {
          _this.scrollTimeout = null;

          _this.scrollFunctions.forEach(function (fn) {
            fn();
          });
        }, 16);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.scrollTimeout = null;
      window.removeEventListener('scroll', this.throttle);
    }
  }]);

  return ScrollThrottler;
}();

exports.ScrollThrottler = ScrollThrottler;

var ResizeThrottler =
/*#__PURE__*/
function () {
  function ResizeThrottler() {
    _classCallCheck(this, ResizeThrottler);

    this.resizeTimeout = null;
    this.resizeFunctions = [];
    this.throttle = this.throttle.bind(this);
    window.addEventListener('resize', this.throttle, false);
  }

  _createClass(ResizeThrottler, [{
    key: "add",
    value: function add(fn) {
      this.resizeFunctions.push(fn);
    }
  }, {
    key: "remove",
    value: function remove(fn) {
      this.resizeFunctions = this.resizeFunctions.filter(function (setFn) {
        return setFn !== fn;
      });
    }
  }, {
    key: "throttle",
    value: function throttle() {
      var _this2 = this;

      if (!this.resizeTimeout) {
        this.resizeTimeout = setTimeout(function () {
          _this2.resizeTimeout = null;

          _this2.resizeFunctions.forEach(function (fn) {
            fn();
          });
        }, 66);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.resizeTimeout = null;
      window.removeEventListener('resize', this.throttle);
    }
  }]);

  return ResizeThrottler;
}();

exports.ResizeThrottler = ResizeThrottler;

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Modal =
/*#__PURE__*/
function () {
  function Modal() {
    _classCallCheck(this, Modal);

    this.playButtons = $('.play');

    if (this.playButtons.length === 0) {
      return;
    }

    this._setupEvents();
  }

  _createClass(Modal, [{
    key: "_appendModal",
    value: function _appendModal(modalTemplate) {
      document.body.insertAdjacentHTML('beforeend', modalTemplate);

      this._setupCloseEvent();

      this._centerModal();
    }
  }, {
    key: "_centerModal",
    value: function _centerModal() {
      var modal = document.getElementById('modal');
      var modalHeight = modal.offsetHeight;
      var windowHeight = window.innerHeight || 0;
      var browserHeight = Math.max(document.documentElement.clientHeight, windowHeight);
      var modalTop = 10;
      var pagePosition = document.documentElement.scrollTop || document.body.scrollTop;

      if (modalHeight < browserHeight) {
        modalTop = browserHeight / 2 - modalHeight / 2;
      }

      modal.style.top = pagePosition + modalTop + 'px';
    }
  }, {
    key: "_closeModal",
    value: function _closeModal(e) {
      var closeButton = document.getElementById('modal-close');
      var overlay = document.getElementById('modal-overlay');
      var modal = document.getElementById('modal'); // If the escape key is pressed and no modal is open, return

      if (!overlay || !modal) {
        return;
      }

      overlay.parentNode.removeChild(overlay);
      modal.parentNode.removeChild(modal);
    }
  }, {
    key: "_updateModalHtml",
    value: function _updateModalHtml(videoUrl) {
      if (!videoUrl) {
        return;
      }

      var modalTemplate = document.getElementById('modal-template').innerHTML;
      var modalHTML = modalTemplate.replace("[[video-url]]", videoUrl);

      this._appendModal(modalHTML);
    }
  }, {
    key: "_setupCloseEvent",
    value: function _setupCloseEvent() {
      var _this = this;

      var closeButton = document.getElementById('modal-close');
      closeButton.addEventListener('click', function (e) {
        e.preventDefault();

        _this._closeModal();
      });
    }
  }, {
    key: "_setupEvents",
    value: function _setupEvents() {
      var _this2 = this;

      this.playButtons.on('click', function (e) {
        e.stopPropagation();
        var $btn = $(e.target);
        var videoProvider = $btn.data('video-provider');
        var videoId = $btn.data('video-id');
        var videoUrl = '';

        if (videoProvider == 'vidyard') {
          videoUrl = 'https://play.vidyard.com/' + videoId;
        } else {
          videoUrl = 'https://www.youtube.com/embed/' + videoId + '?rel=0&amp;showinfo=0&autoplay=1';
        }

        _this2._updateModalHtml(videoUrl);
      });
      document.addEventListener('keyup', function (e) {
        var isEscape = e.keyCode === 27;

        if (isEscape) {
          _this2._closeModal();
        }
      });
    }
  }]);

  return Modal;
}();

var _default = Modal;
exports.default = _default;

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WallOfGratitude =
/*#__PURE__*/
function () {
  function WallOfGratitude() {
    var _this = this;

    _classCallCheck(this, WallOfGratitude);

    this.$wallFormContainer = $('#cheer-comment-form-wrap');

    if (this.$wallFormContainer.length <= 0) {
      return;
    }

    this.currentPage = 1; // Used to load more posts

    this.textAreas = _toConsumableArray(document.getElementsByTagName('textarea')).filter(function (textarea) {
      return _this._getTextAreaMaxLength(textarea);
    });
    this.$wallForm = this.$wallFormContainer.find('form');
    this.res_messages = {
      'FILL_REQUIRED_FIELDS': 'Please fill out all fields.',
      'GENERAL_ISSUE': 'An issue has occurred. Please try again!',
      'RECAPTCHA_VERIFICATION_FAILED': 'reCAPTCHA verification failed, please try again.'
    };
    this.init();
  }

  _createClass(WallOfGratitude, [{
    key: "savePost",
    value: function savePost() {
      var isValid = this.validate();

      if (!isValid) {
        grecaptcha.reset();
        return;
      }

      $.ajax({
        url: '/actions/wallOfGratitude/posts/savePost',
        type: 'POST',
        data: this.$wallForm.serialize(),
        dataType: 'json',
        context: this,
        success: function success(res) {
          console.log('response ->', res);

          if (res.status === 200) {
            this._showThankYou();

            this._updateShareButtonLinks();

            this._resetForm();

            return;
          }

          this._showFormMessage(res.message);
        },
        error: function error(err) {
          grecaptcha.reset();
          var statusCode = err.status;

          if (statusCode === 403) {
            this._showFormMessage('There was an error trying to send your message. Please try again.');

            return;
          }

          this._showFormMessage('Server is not responding. Please try again.');
        }
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      var comment = $('#comment').val();

      if (!comment) {
        this._showFormMessage('FILL_REQUIRED_FIELDS');

        return false;
      }

      return true;
    }
  }, {
    key: "_appendPosts",
    value: function _appendPosts(posts) {
      var $wallPostTemplate = $('#wall-post-template');
      var $wallPostContainer = $('.cheer-comments .comment-list');
      var wallPostTemplateHtml = $wallPostTemplate.html();
      var wallHtml = "";

      for (var i = 0; i < posts.length; i++) {
        wallHtml += wallPostTemplateHtml.replace(/{ message }/g, posts[i]['message']).replace(/{ font }/g, posts[i]['font']).replace(/{ color }/g, posts[i]['color']);
      }

      $wallPostContainer.append(wallHtml);

      this._hideLoading();
    }
  }, {
    key: "_hideLoading",
    value: function _hideLoading() {
      $('.loading').addClass('hide');
    }
  }, {
    key: "_hideLoadMore",
    value: function _hideLoadMore() {
      $('.load-more').remove();

      this._hideLoading();
    }
  }, {
    key: "_loadMorePosts",
    value: function _loadMorePosts() {
      this._showLoading();

      $.ajax({
        url: '/actions/wallOfGratitude/posts/getMorePosts',
        type: 'GET',
        data: {
          page: this.currentPage
        },
        dataType: 'json',
        context: this,
        success: function success(res) {
          if (res.status === 200) {
            if (res.posts.length <= 0) {
              this._hideLoadMore();

              return;
            }

            this._appendPosts(res.posts);

            return;
          }
        },
        error: function error(err) {
          this._hideLoading();
        }
      });
    }
  }, {
    key: "_resetForm",
    value: function _resetForm() {
      this.$wallForm[0].reset();
    }
  }, {
    key: "_showFormMessage",
    value: function _showFormMessage(message) {
      var formMessage = this.res_messages[message] ? this.res_messages[message] : message;
      this.$wallFormContainer.find('.form-message').text(formMessage);
    }
  }, {
    key: "_showLoading",
    value: function _showLoading() {
      $('.loading').removeClass('hide');
    }
  }, {
    key: "_showThankYou",
    value: function _showThankYou() {
      this.$wallFormContainer.find('.thank-you').addClass('show');
      this.$wallForm.addClass('hidden');
    }
  }, {
    key: "_updateShareButtonLinks",
    value: function _updateShareButtonLinks() {
      var siteUrl = document.location.origin + document.location.pathname;
      var comment = this.$wallForm.find('#comment').val();
      $('.share.twitter').attr('href', 'http://twitter.com/share?text=' + comment + ' %232020thankful&url=' + siteUrl);
      $('.share.facebook').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + siteUrl + '&quote=' + comment + ' %232020thankful');
    } // Textarea

  }, {
    key: "_appendCharacterCounterDiv",
    value: function _appendCharacterCounterDiv() {
      var _this2 = this;

      this.textAreas.forEach(function (textarea) {
        var parentEl = textarea.parentElement;
        var counterDiv = document.createElement('div');
        var counterNumberSpan = document.createElement('span');
        counterDiv.classList.add('character-count');
        counterNumberSpan.innerText = _this2._getTextAreaMaxLength(textarea);
        counterDiv.appendChild(counterNumberSpan);
        parentEl.appendChild(counterDiv);

        _this2._updateRemainingCharacterCount(textarea);
      });
    }
  }, {
    key: "_getTextAreaMaxLength",
    value: function _getTextAreaMaxLength(textarea) {
      return textarea.getAttribute('maxlength') || textarea.getAttribute('data-val-formmaxlength-maxlength');
    } // Prevent user from typing more than maxLength characters (taking into account that new lines (\n) are equal to 2 characters)

  }, {
    key: "_limitTextareaToMaxLengthCharacters",
    value: function _limitTextareaToMaxLengthCharacters(textarea) {
      var characterCount = textarea.value.replace(this.newLineRegex, '--').length; // Get length - Count new lines (\n) as 2 characters

      var maxLength = this._getTextAreaMaxLength(textarea);
      /*
         If characterCount is greater than set maxLength, get the new textarea value by:
             - Taking the current textarea value
             - Replacing all occurrences of New line (\n) with a Carriage Return + New Line (\r\n)
             - Getting the substring of that value using the maxLength as the indexEnd parameter (e.q. If maxLength is 500, return the first 500 characters)
             - Set textarea's value equal to the new textarea value
      */


      if (characterCount > maxLength) {
        var newTextareaValue = textarea.value.replace(this.newLineRegex, '\r\n').substring(0, maxLength); // This value will always be <= the maxLength set

        if (newTextareaValue.replace(this.newLineRegex, '--').length > maxLength) {
          newTextareaValue = newTextareaValue.substring(0, maxLength - 1);
        }

        textarea.value = newTextareaValue;
      }
    }
  }, {
    key: "_remainingCharacters",
    value: function _remainingCharacters(element) {
      var characterCount = element.value.replace(this.newLineRegex, '--').length;
      return this._getTextAreaMaxLength(element) - characterCount;
    }
  }, {
    key: "_updateRemainingCharacterCount",
    value: function _updateRemainingCharacterCount(textarea) {
      var parentEl = textarea.parentElement;
      var characterCountEl = parentEl.querySelector('.character-count span');
      characterCountEl.innerText = this._remainingCharacters(textarea);
    }
  }, {
    key: "_setupEvents",
    value: function _setupEvents() {
      var _this3 = this;

      var $btn = $('.cheer-comments .load-more');
      $btn.on('click', function () {
        _this3.currentPage++;

        _this3._loadMorePosts();
      }); // Textarea Character Count

      this.textAreas.forEach(function (textarea) {
        textarea.addEventListener('input', function () {
          _this3._limitTextareaToMaxLengthCharacters(textarea);
        });
        textarea.addEventListener('keyup', function (e) {
          _this3._updateRemainingCharacterCount(e.target);
        });
      });
    }
  }, {
    key: "init",
    value: function init() {
      this._appendCharacterCounterDiv();

      this._setupEvents();
    }
  }]);

  return WallOfGratitude;
}();

var _default = WallOfGratitude;
exports.default = _default;

},{}]},{},[19])

